import env from '~/env';
import ethLogo from './assets/network_icon/ethereum-eth-logo.png';
import klayLogo from './assets/network_icon/klaytn-klay-logo.png';
import kaiaLogo from './assets/network_icon/kaia-kaia-logo.png';
import solLogo from './assets/network_icon/solana-sol-logo.png';
import bnbLogo from './assets/network_icon/binance-bnb-logo.png';
import maticLogo from './assets/network_icon/polygon-pol-logo.png';
import titanLogo from './assets/network_icon/titan-logo.png';
import klay from '~/design/img/i_klay.svg';
import kaia from '~/design/img/i_kaia.svg';
import usdt from '~/design/img/i_usdt.svg';
import usdc from '~/design/img/i_usdc.png';
import matic from '~/assets/network_icon/polygon-pol-logo.png';
import ruby from '~/assets/network_icon/polygon-pol-logo.png';
import liq from '~/assets/network_icon/polygon-pol-logo.png';
import tin from '~/assets/network_icon/polygon-pol-logo.png';

export const infuraApiKey = env.REACT_APP_INFURA_API_KEY;

export const ChainId = {
  MAINNET: 1,
  SEPOLIA: 11155111,
  BSCMAINNET: 56,
  BSCTESTNET: 97,
  KLAYTN: 8217,
  BAOBAB: 1001,
  MUMBAI: 80001,
  POLYGON: 137,
  TMP: 203,
  TTITAN: 85011,
  MTITAN: 84358,
};

export const NETWORK_NAME = {
  [ChainId.MAINNET]: 'Ethereum Mainnet',
  [ChainId.SEPOLIA]: 'Ethereum Sepolia',
  [ChainId.KLAYTN]: 'Klaytn Cypress',
  [ChainId.BAOBAB]: 'Klaytn Baobab',
  [ChainId.TMP]: 'Klaytn TMP Testnet',
  [ChainId.BSCMAINNET]: 'Binance Smart Chain Mainnet',
  [ChainId.BSCTESTNET]: 'BSC Testnet',
  [ChainId.MUMBAI]: 'Polygon Testnet',
  [ChainId.POLYGON]: 'Polygon Mainnet',
  [ChainId.TTITAN]: 'Titan Testnet',
  [ChainId.MTITAN]: 'Titan Mainnet',
};

export const SCAN_URL = {
  [ChainId.MAINNET]: 'https://etherscan.io/',
  [ChainId.SEPOLIA]: 'https://sepolia.etherscan.io/',
  [ChainId.KLAYTN]: 'https://kaiascan.io/',
  [ChainId.BAOBAB]: 'https://kairos.kaiascan.io/',
  [ChainId.BSCMAINNET]: 'https://bscscan.com/',
  [ChainId.BSCTESTNET]: 'https://testnet.bscscan.com/',
  [ChainId.MUMBAI]: 'https://mumbai.polygonscan.com/',
  [ChainId.POLYGON]: 'https://polygonscan.com/',
  [ChainId.TTITAN]: 'https://subnets-test.avax.network/criminalsa',
  [ChainId.MTITAN]: 'https://subnets.avax.network/titan',
};

const RPC_URL_MAINNET = `https://mainnet.infura.io/v3/${infuraApiKey}`;
const RPC_URL_SEPOLIA = `https://sepolia.infura.io/v3/${infuraApiKey}`;

export const RPC_URLS = {
  [ChainId.MAINNET]: RPC_URL_MAINNET,
  [ChainId.SEPOLIA]: RPC_URL_SEPOLIA,
  [ChainId.BSCMAINNET]: 'https://bsc-dataseed.binance.org',
  [ChainId.BSCMAINNET]: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  [ChainId.BAOBAB]: 'https://public-en-kairos.node.kaia.io',
  [ChainId.KLAYTN]: 'https://klaytn-en.kommunedao.xyz:8651',
  [ChainId.TMP]: 'https://klaytn.dev.tmpcic.studio',
  [ChainId.MUMBAI]: 'https://rpc-mumbai.maticvigil.com/',
  [ChainId.POLYGON]: 'https://polygon-rpc.com/',
  [ChainId.TTITAN]:
    'https://testnet-criminalsa-vcd6c.avax-test.network/ext/bc/Hb3EduWUYuKWvENKL6NYqjZFYRMXriBfhaSojT7dSn7SjQZzU/rpc?token=72b6af7102f97af3dd1b361f204693c233a7bd2534c76132b523ba68af41c31b',
  // [ChainId.TTITAN]: 'https://subnets.avax.network/criminalsa/testnet/rpc',
  [ChainId.MTITAN]: 'https://subnets.avax.network/titan/mainnet/rpc',
};

export const IPFS_URL = 'https://ipfs.io/ipfs/';
export const ALT_URL = env.REACT_APP_ALT_URL;
export const SUCCESS = 1;
export const FAILURE = 0;

export const targetNetwork = env.REACT_APP_TARGET_NETWORK_KLAY;
export const targetNetworkMsg = env.REACT_APP_TARGET_NETWORK_MSG;

export const NETWORKS = [
  // {
  //   id: 0,
  //   value: env.REACT_APP_TARGET_NETWORK_ETH,
  //   label: 'Ethereum',
  //   icon: ethLogo,
  // },
  {
    id: 1,
    value: env.REACT_APP_TARGET_NETWORK_KLAY,
    label: 'Kaia',
    icon: kaiaLogo,
  },
  // {
  //   id: 2,
  //   value: env.REACT_APP_TARGET_NETWORK_SOL,
  //   label: 'Solana',
  //   icon: solLogo,
  // },
  // {
  //   id: 3,
  //   value: env.REACT_APP_TARGET_NETWORK_BNB,
  //   label: 'Binance',
  //   icon: bnbLogo,
  // },
  // {
  //   id: 4,
  //   value: env.REACT_APP_TARGET_NETWORK_MATIC,
  //   label: 'Polygon',
  //   icon: maticLogo,
  // },
  {
    id: 5,
    value: env.REACT_APP_TARGET_NETWORK_TITAN,
    label: 'Titan',
    icon: titanLogo,
  },
];

export const QUOTE_LIST = {
  [ChainId.BAOBAB]: [
    { id: 1, icon: kaia, value: 'kaia', title: 'KAIA' },
    { id: 2, icon: usdt, value: 'usdt', title: 'USDT' },
    { id: 3, icon: usdc, value: 'usdc', title: 'USDC' },
  ],
  [ChainId.KLAYTN]: [
    { id: 1, icon: kaia, value: 'kaia', title: 'KAIA' },
    { id: 2, icon: usdt, value: 'usdt', title: 'USDT' },
    { id: 3, icon: usdc, value: 'usdc', title: 'USDC' },
  ],
  [ChainId.MUMBAI]: [
    { id: 1, icon: matic, value: 'matic', title: 'MATIC' },
    { id: 2, icon: usdt, value: 'usdt', title: 'USDT' },
    { id: 3, icon: usdc, value: 'usdc', title: 'USDC' },
  ],
  [ChainId.POLYGON]: [
    { id: 1, icon: matic, value: 'matic', title: 'MATIC' },
    { id: 2, icon: usdt, value: 'usdt', title: 'USDT' },
    { id: 3, icon: usdc, value: 'usdc', title: 'USDC' },
  ],
  [ChainId.TTITAN]: [
    { id: 1, icon: ruby, value: 'ruby', title: 'RUBY' },
    { id: 2, icon: liq, value: 'liq', title: 'LIQ' },
  ],
  [ChainId.MTITAN]: [
    { id: 1, icon: ruby, value: 'ruby', title: 'RUBY' },
    { id: 2, icon: tin, value: 'tin', title: 'TIN' },
  ],
};

export const getSelectedNodeUrl = (chainId: number) => {
  switch (chainId) {
    case ChainId.MAINNET:
      return RPC_URLS[ChainId.MAINNET];
    case ChainId.SEPOLIA:
      return RPC_URLS[ChainId.SEPOLIA];
    case ChainId.KLAYTN:
      return RPC_URLS[ChainId.KLAYTN];
    case ChainId.BAOBAB:
      return RPC_URLS[ChainId.BAOBAB];
    case ChainId.BSCMAINNET:
      return RPC_URLS[ChainId.BSCMAINNET];
    case ChainId.BSCTESTNET:
      return RPC_URLS[ChainId.BSCTESTNET];
    case ChainId.MUMBAI:
      return RPC_URLS[ChainId.MUMBAI];
    case ChainId.POLYGON:
      return RPC_URLS[ChainId.POLYGON];
    case ChainId.TTITAN:
      return RPC_URLS[ChainId.TTITAN];
    case ChainId.MTITAN:
      return RPC_URLS[ChainId.MTITAN];
    default:
      return RPC_URLS[ChainId.KLAYTN];
  }
};
